const Dashboard = () => import('@/views/Dashboard');

export default [
	{
		path: '/dashboard',
		name: 'dashboard',
		component: Dashboard,
		meta: {
			title: 'Panel',
			layout: 'layout',
			requiresAuth: true,
			isSuperUser: true,
		},
	},
];
